export default "__VITE_ASSET__BP37uLg5__"